import React, { useState, useEffect, useContext } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import SelectLabels from "../../components/SelectLabels";
import { axiosInstance } from "../../axiosInstance";
import { ProfileDetailsContext } from "../../context/ProfileDetailsProvider";
import { notify } from "../../components/toastify";

function EditLoyaltyPoint({
  singleData,
  setSingleData,
  fetchCategories,
  setEdittab,
  currentPage,
}) {
  const { profileDetails } = useContext(ProfileDetailsContext);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    minimum_price: "",
    discount_type: "",
    discount_value: "",
    description: "",
    status: "",
  });

  // Initialize form data from singleData when component mounts or singleData changes
  useEffect(() => {
    if (singleData) {
      setFormData({
        name: singleData?.name || "",
        minimum_price: singleData?.minimum_price || "",
        discount_type: singleData?.discount_type || "",
        discount_value: singleData?.discount_value || singleData?.point || "",
        description: singleData?.description || singleData?.short_description || "",
        status: singleData?.status || "",
      });
    }
  }, [singleData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleStatusChange = (id) => {
    const statusValue = id === 1 ? "active" : "inactive";
    setFormData((prevData) => ({ ...prevData, status: statusValue }));
  };

  const handleDiscountTypeChange = (id) => {
    const discountType = id === 1 ? "percentage" : "fixed";
    setFormData((prevData) => ({ ...prevData, discount_type: discountType }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Get company_id from profileDetails
    const companyId = profileDetails?.user?.company_id;

    if (!companyId) {
      notify("Company ID not found. Please refresh and try again.", "error");
      return;
    }

    if (!singleData?.id) {
      notify("Discount ID not found. Please refresh and try again.", "error");
      return;
    }

    setLoading(true);

    try {
      const requestData = {
        company_id: companyId,
        name: formData.name,
        minimum_price: Number(formData.minimum_price),
        discount_type: formData.discount_type,
        discount_value: Number(formData.discount_value),
        description: formData.description || "",
        status: formData.status,
      };

      const response = await axiosInstance.put(
        `api/discounts/${singleData.id}`,
        requestData
      );

      if (response?.data?.error === false) {
        notify(response?.data?.message || "Discount updated successfully", "success");
        fetchCategories(currentPage);
        setEdittab(false);
      } else {
        notify(response?.data?.message || "Failed to update discount", "error");
      }
    } catch (error) {
      console.error("Error updating discount:", error);
      notify(
        error?.response?.data?.message || "Failed to update discount",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>
      <h2 className="text-2xl font-medium text-center">Edit Discount</h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex flex-col flex-wrap justify-center lg:flex-row gap-6 ">
          <div className="flex flex-col">
            <label htmlFor="">Name</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="flex flex-col">
            <label htmlFor="">Minimum Price</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Minimum Price"
              type="number"
              name="minimum_price"
              value={formData.minimum_price}
              onChange={handleChange}
              min="0"
              required
            />
          </div>

          <div className="flex flex-col lg:w-[400px]">
            <label htmlFor="">Discount Type</label>
            <SelectLabels
              categoryData={[
                { id: 0, name: "Fixed" },
                { id: 1, name: "Percentage" },
              ]}
              text="Select Discount Type"
              valueKey="id"
              labelKey="name"
              onSelectChange={handleDiscountTypeChange}
              previousValue={formData.discount_type === "percentage" ? 1 : formData.discount_type === "fixed" ? 0 : ""}
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Discount Value</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Discount Value"
              type="number"
              name="discount_value"
              value={formData.discount_value}
              onChange={handleChange}
              min="0"
              required
            />
          </div>

          <div className="flex flex-col">
            <label htmlFor="">Description</label>
            <input
              className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
              placeholder="Description"
              type="text"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className="flex flex-col lg:w-[400px]">
            <label htmlFor="">Status</label>
            <SelectLabels
              categoryData={[
                { id: 0, name: "Inactive" },
                { id: 1, name: "Active" },
              ]}
              text="Select Status"
              valueKey="id"
              labelKey="name"
              onSelectChange={handleStatusChange}
              previousValue={formData.status === "active" ? 1 : formData.status === "inactive" ? 0 : ""}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
        >
          {loading ? "Updating Discount..." : "Update Discount"}
        </button>
      </form>
    </div>
  );
}

export default EditLoyaltyPoint;
